import React, { useEffect, useState } from "react";
import { Inbox, Trash2, MailOpen, Reply, RefreshCw } from "lucide-react";
import { fetchMessages, markMessageRead, deleteMessage } from "../../lib/api";
import { toast } from "../../hooks/use-toast";

const MessagesPanel = () => {
  const [msgs, setMsgs] = useState(null);
  const load = () => fetchMessages().then(setMsgs).catch(() => setMsgs([]));
  useEffect(() => { load(); }, []);
  if (!msgs) return <div className="text-slate-400">Loading...</div>;

  const read = async (m) => { await markMessageRead(m.id); setMsgs((p) => p.map((x) => (x.id === m.id ? { ...x, read: true } : x))); };
  const remove = async (m) => {
    if (!window.confirm("Delete this message?")) return;
    await deleteMessage(m.id); setMsgs((p) => p.filter((x) => x.id !== m.id)); toast({ title: "Deleted" });
  };

  return (
    <div data-testid="admin-messages-panel">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-white font-bold text-lg">Customer Messages ({msgs.length})</h3>
        <button onClick={load} className="inline-flex items-center gap-2 text-sm text-white border border-gold/30 hover:border-gold px-3 py-2 rounded-lg transition-colors"><RefreshCw size={15} /> Refresh</button>
      </div>
      {msgs.length === 0 ? (
        <div className="text-center py-16 text-slate-400"><Inbox size={40} className="mx-auto text-navy-600 mb-4" /><p>No messages yet. Messages from the Contact page appear here.</p></div>
      ) : (
        <div className="space-y-4">
          {msgs.map((m) => (
            <div key={m.id} data-testid={`message-${m.id}`} className={`bg-navy-800 rounded-2xl border p-5 ${m.read ? "border-white/10" : "border-gold/50"}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="text-white font-semibold">{m.name} {!m.read && <span className="ml-2 text-[10px] uppercase tracking-wider bg-gold text-navy px-2 py-0.5 rounded-full">New</span>}</p>
                  <p className="text-slate-400 text-xs">{m.email} · {new Date(m.createdAt).toLocaleString()}</p>
                </div>
                <div className="flex gap-2">
                  <a href={`mailto:${m.email}?subject=${encodeURIComponent("Re: " + (m.subject || "Your message"))}`} onClick={() => read(m)} className="inline-flex items-center gap-1.5 text-xs text-navy bg-gold hover:bg-gold-light px-3 py-1.5 rounded-lg transition-colors"><Reply size={13} /> Reply</a>
                  {!m.read && <button onClick={() => read(m)} className="inline-flex items-center gap-1.5 text-xs text-white border border-white/15 hover:border-gold px-3 py-1.5 rounded-lg transition-colors"><MailOpen size={13} /> Mark read</button>}
                  <button onClick={() => remove(m)} className="h-8 w-8 rounded-lg border border-white/15 text-slate-400 flex items-center justify-center hover:text-red-400 transition-colors"><Trash2 size={14} /></button>
                </div>
              </div>
              {m.subject && <p className="text-gold text-sm mt-3">{m.subject}</p>}
              <p className="text-slate-300 text-sm mt-2 whitespace-pre-wrap">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MessagesPanel;
